import { render, staticRenderFns } from "./MakeCollection.vue?vue&type=template&id=14fed27e&scoped=true&"
import script from "./MakeCollection.vue?vue&type=script&lang=js&"
export * from "./MakeCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fed27e",
  null
  
)

export default component.exports